import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import moment from 'moment';

import { getCreditsHistory } from '../store/actions/carHouse-actions';
import { Table } from 'antd';

import Spinner from '../components/UI/Spinner/Spinner';

const CreditsHistory = () => {
  const { credits, isLoading } = useSelector((state) => state.carHouse);
  const dispatch = useDispatch();
  const { carHouseId } = useParams();

  const columns = [
    {
      title: 'Date',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (item) => <>{moment(item).format('DD/MM/YYYY HH:mm:ss')}</>,
    },
    {
      title: 'Reason',
      dataIndex: 'reason',
      key: 'reason',
    },
    {
      title: 'Credits',
      dataIndex: 'credits',
      key: 'credits',
    },
    {
      title: 'User Id',
      dataIndex: 'id',
      key: 'userId',
    },
  ];

  useEffect(() => {
    dispatch(getCreditsHistory(carHouseId));
  }, [dispatch, carHouseId]);

  let content;

  isLoading
    ? (content = <Spinner />)
    : (content = (
        <>
          <h1>Credits History</h1>
          <Table
            columns={columns}
            dataSource={credits.results}
            rowKey={(record) => record.id}
          />
        </>
      ));

  return <>{content}</>;
};

export default CreditsHistory;
